import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelFamily.${param}`)
export default (form = {}) => {
  const column = [
    {
      label: i18n('relation'),
      field: 'relation',
      dictField: 'relationName',
      formOption: {
        type: 'select',
        dictBizCode: 'staff_relation',
        rules: 'required',
      },
    },
    {
      label: i18n('name'),
      field: 'name',
      formOption: {
        rules: 'required',
      },
    },
    {
      label: i18n('sex'),
      field: 'sex',
      dictField: 'sexName',
      formOption: {
        type: 'select',
        dictBizCode: 'gender',
        rules: 'required',
      },
    },
    {
      label: i18n('nationality'),
      field: 'nationality',
      formOption: {
        type: 'select',
        dictCode: 'nationality',
        rules: 'required',
      },
    },
    {
    // label: i18n('nationality'),
      label: 'Child Birth CertNo',
      field: 'childBirthCertNo',
      hide: true,
      formOption: {
        hide: form.relation !== '4',
        rules: 'required',
      },
    },
    {
    // label: i18n('sex'),
      label: 'Child Citizen Ship',
      field: 'childCitizenship',
      dictField: 'childCitizenshipName',
      hide: true,
      formOption: {
        type: 'select',
        dictBizCode: 'child_citizenship',
        hide: form.relation !== '4',
        rules: 'required',
      },
    },
    {
      label: i18n('mobile'),
      field: 'mobile',
    },
    {
      label: i18n('email'),
      field: 'email',
      formOption: {
        rules: 'email',
      },
    },
    {
      label: i18n('birthday'),
      field: 'birthday',
      formOption: {
        type: 'date',
        rules: 'required',
      },
    },
    {
      label: i18n('adderss'),
      field: 'adderss',
    },
  ]
  return column
}
